import React from "react";
import { FlatButton, Card, CardText } from "material-ui";
import { commitMutation, graphql } from "react-relay";
import PropTypes from "prop-types";
import { Prompt } from "react-router-dom";

import environment from "../../relay/environment";

export default class AddNotes extends React.Component {
  static propTypes = {
    onComplete: PropTypes.func.isRequired,
    trip: PropTypes.shape().isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      note: "",
      submitting: false
    };

    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill"); // eslint-disable-line global-require
    }
  }

  updateNote = value => {
    this.setState({ note: value });
  };

  save = () => {
    this.setState({ submitting: true });

    const {
      onComplete,
      trip: { id: tripId }
    } = this.props;
    const { note } = this.state;

    commitMutation(environment, {
      mutation: graphql`
        mutation AddNote_AddNoteToTrip_Mutation($input: AddNoteInput!) {
          addNote(input: $input) {
            trip {
              history {
                id
              }
              notes {
                owner {
                  firstName
                }
                content
                created
              }
            }
          }
        }
      `,
      variables: { input: { tripId, note } },
      onCompleted: () => onComplete(),
      onError: err => {
        this.setState({ submitting: false });
        alert(err);
      }
    });
  };

  render() {
    const { onComplete } = this.props;
    const { note, submitting } = this.state;

    return (
      <Card>
        <CardText>
          <Prompt message="You are currently adding a note, leaving now will discard any changes made." />
          <this.ReactQuill value={note} onChange={this.updateNote} />
          <div style={styles.noteActions}>
            <FlatButton
              label="Cancel"
              secondary
              onTouchTap={onComplete}
              disabled={submitting}
            />
            <FlatButton
              label="Add Note"
              primary
              onTouchTap={this.save}
              disabled={submitting}
            />
          </div>
        </CardText>
      </Card>
    );
  }
}

const styles = {
  noteActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  }
};



// WEBPACK FOOTER //
// /src/components/Trips/AddNote.js